import { EnvironmentProviders, makeEnvironmentProviders, Provider, Type } from '@angular/core';
import { resolveTscConfig, TSC_CONFIG, TscConfig } from './tsc-config';
import { TscPageTitle } from './tsc-page-title';

/** Optional override of a default port, passed to `provideTsc(config, ...features)`. */
export interface TscFeature {
  kind: 'pageTitle';
  providers: Provider[];
}

/**
 * Registers the ticket UI configuration (value or factory; the factory runs in an injection context, so `inject()`
 * works there) and optional port overrides. Requires `provideSharedUi()` (API base URL + token).
 * The ticket state (`TicketStore`, `@ngrx/signals`) is provided by `TSC_ROUTES` itself and torn down when the user leaves the ticket routes.
 */
export function provideTsc(config: TscConfig | (() => TscConfig), ...features: TscFeature[]): EnvironmentProviders {
  return makeEnvironmentProviders([
    typeof config === 'function'
      ? { provide: TSC_CONFIG, useFactory: () => resolveTscConfig(config()) }
      : { provide: TSC_CONFIG, useValue: resolveTscConfig(config) },
    ...features.flatMap(feature => feature.providers),
  ]);
}

/** Replaces the default page title port (Angular `Title` + ngx-translate). */
export function withPageTitle(impl: Type<TscPageTitle>): TscFeature {
  return { kind: 'pageTitle', providers: [{ provide: TscPageTitle, useClass: impl }] };
}
